import axios from 'axios';
import config from '../config';
import { useQuery } from 'react-query';
import { useState } from 'react';

export default function useSearchChildByParentID(
  searchInfoSetter = null,
  labelSetter
) {
  const [msg, setMsg] = useState('');
  const [otp, setOtp] = useState('');
  const [parentIdQuery, setParentIdQuery] = useState('');
  const [showOtpField, setShowOtpField] = useState(false);

  // API Call structuring
  const fetchSearchResults = async id => {
    setMsg('');
    if (!id) return null;
    const parentData = new FormData();
    parentData.append('mode', 'getStudentByParentId');
    parentData.append('searchString', id);
    if (otp !== '') parentData.append('otp', otp);

    const output = await axios.post(config.STUDENTS_API, parentData);
    if (output.data.response !== 'INVALID') {
      if (output.data.response.status === 'OK') {
        searchInfoSetter(output.data.response);
      } else if (output.data.response.status === 'REQUIRE-OTP') {
        setShowOtpField(true);
        labelSetter(
          'An OTP has been sent to this  email address. Enter it below to continue.'
        );
      } else if (output.data.response.status === 'OTP-ERROR') {
        setMsg(
          'Unable to generate OTP for this email address. Please contact Administrator <catechists@olps.sg>'
        );
      } else if (output.data.response.status === 'OTP-BADAUTH') {
        setMsg(
          'This OTP is invalid or expired. To receive a new code, please refresh this page.'
        );
      } else {
        setMsg('You have entered an invalid ID number');
      }
    } else {
      setMsg('Invalid Parent Identification');
    }
  };

  const { isLoading } = useQuery(
    ['parentSearch', parentIdQuery, otp],
    () => fetchSearchResults(parentIdQuery),
    {
      staleTime: 0,
    }
  );

  // START SEARCH
  const searchParentById = id => {
    if (!id) {
      setMsg('Please enter the last 4 characters of your NRIC / FIN');
      return;
    }
    setParentIdQuery(id);
  };

  return { searchParentById, msg, showOtpField, setOtp, isLoading };
}
